import { assertUnreachableOrReturnDefault } from './assertUnreachable';
import { BillingPlanKind, BillingPlanTier } from './graphqlTypes/types';

/**
 * Return mapped name for different plan tiers and kinds
 * @param name plan name stored in DB
 * @param tier BillingPlanTier
 * @param kind BillingPlanKind
 * @returns string
 */
export const planNameMapper = (
  name: string,
  tier: BillingPlanTier,
  kind: BillingPlanKind,
): string => {
  switch (tier) {
    case BillingPlanTier.ENTERPRISE:
      return kind === BillingPlanKind.DEDICATED
        ? name
        : kind === BillingPlanKind.ENTERPRISE_TRIAL
          ? 'Enterprise Trial'
          : 'Enterprise';
    case BillingPlanTier.TEAM:
      return 'Team';
    case BillingPlanTier.COMMUNITY:
      return 'Legacy Free';
    case BillingPlanTier.DEVELOPER:
      return 'Developer';
    case BillingPlanTier.STANDARD:
      return 'Standard';
    // Before standardizing on the plan names "Developer" and "Standard"
    // we used the the Tier "Scale" for basically everything.
    // BillingPlanKind.SCALE_BASIC -> Developer
    // BillingPlanKind.SCALE_ADVANCED -> Standard
    case BillingPlanTier.SCALE:
      if (kind === BillingPlanKind.SCALE_BASIC) return 'Developer';
      if (kind === BillingPlanKind.SCALE_ADVANCED) return 'Standard';
      return 'Scale';
    case BillingPlanTier.FREE:
    case BillingPlanTier.NONE:
    case BillingPlanTier.UNKNOWN:
    case BillingPlanTier.USAGE_BASED:
      return name;
    default:
      return assertUnreachableOrReturnDefault(tier, name);
  }
};
